import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 2026-10-07：记录商品详情链的原列表入口，供平板顶部分类返回时复用。
import { installCatalogReturnNavigation } from './utils/catalogReturnNavigation'

import Antd from 'ant-design-vue'
// import '@/assets/styles/antd.css';
import '@/assets/styles/index.scss'
// 2026-09-30：手机网页统一为小程序式布局，仅在768px及以下生效。
import '@/assets/styles/mobile.scss'
import '@/assets/styles/mobileCheckout.scss'
import installIcons from '@/assets/icons/index'
import i18n from '@/i18n/index'
import './router/permission'
// import { generateNewStyle } from '@/utils/theme'
// import API from 'fghis-ui'
// import 'fghis-ui/dist/css/index.css'
import Loading from '@/components/cLoading'

import CommonUi from '@/components/index'
installCatalogReturnNavigation(router, () => String(store.getters.orgId) + ':' + String(store.getters.userInfo.id || 0))
const app = createApp(App)
// console.log(CommonUi)
installIcons(app)
// API.install(app)
app.use(store).use(router).use(Antd).use(Loading).use(CommonUi).use(i18n).mount('#app')
// generateNewStyle(store.getters.theme)
